import React from 'react';

import ExpLabel from '@exp/components/localization/ExpLabel';

import { selectIsHeaderVisible } from '../redux/context';
import { useAppSelector } from '../redux/hooks';
import { TemplateProps } from './types';

import './ModalLayoutV1.less';

/**
 * Modal Layout - V1 Theme
 */
const ModalLayoutV1 = React.forwardRef<HTMLDivElement, TemplateProps>(
  ({ children = null, onClose = null, onPrevious = null, onSkip = null }, ref) => {
    const isHeaderVisible: boolean = useAppSelector(selectIsHeaderVisible);
    const hasHandlers: boolean = Boolean(onClose || onPrevious || onSkip);
    return (
      <div className="exp-modal" data-theme="v1" ref={ref}>
        {isHeaderVisible && hasHandlers && (
          <div className="exp-modal-header">
            {onPrevious && (
              <button aria-label="Back" className="exp-onb-back-btn btn-wp-reset" onClick={onPrevious} type="button">
                <i className="exp-ux-small exp-ux-arrow" />
              </button>
            )}
            {onClose && !onSkip && (
              <button aria-label="Close" className="exp-modal-close btn-wp-reset" onClick={onClose} type="button">
                <i className="exp-ux-small exp-ux-close" />
              </button>
            )}
            {onSkip && (
              <button aria-label="Skip" className="exp-onb-skip-btn btn-wp-reset" onClick={onSkip} type="button">
                <ExpLabel defaultMessage="Skip" messageKey="onb.button.skip" />
              </button>
            )}
          </div>
        )}
        <div className="exp-modal-content">{children}</div>
      </div>
    );
  },
);

ModalLayoutV1.displayName = 'ModalLayoutV1';

export default ModalLayoutV1;
